export const apiUrl = "https://secondchic.azurewebsites.net/api/v1/secondchic";
export const socketUrl = "https://secondchic.azurewebsites.net";

// export const apiUrl =
//   "https://59ee-39-58-51-119.ngrok-free.app/api/v1/secondchic";
// export const socketUrl = "https://59ee-39-58-51-119.ngrok-free.app";

// export const apiUrl = "http://desktop-a2hhv4s:8000/api/v1/secondchic";
// export const socketUrl = "http://desktop-a2hhv4s:8000";

export const BaseUrl = (url) => `${apiUrl}/${url}`;
export const apiKey = "AIzaSyAFsEP9H8HabaWXDeZzpZZ7-7JuVnXv2yk";
export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const recordLimit = 10;
export const chatRecordLimit = 40;

// export const apiKey = "AIzaSyBSzp2Q-i_VkdIHnxJSfGw8YYO3Gfp5zP8";
